import React from "react";
import "./Nav.css";

class Nav extends React.Component {
  render() {
    return (
      <div>
        <div className="bottom-nav">
          <div class="row">
            <div className="col-2">
              <img style={{height: '90px', width: '90px'}} className="ml-5" src="https://i.imgur.com/NFCLEv8.jpg" alt=""/>
            </div>
            <div className="col-4 ml-2">
              <p className="my-3" style={{fontWeight: 'bold', fontSize: '18px'}}>Good Morning Bamboo Agro-Forestry<br/> And Investment Services</p>
            </div>
            <div className="col-3 ml-auto">
            <p style={{margin: '0', fontWeight: 'bold'}}>Mob: +233509160497</p>
            <p style={{margin: '0', fontWeight: 'bold'}}>Tel: +23352195223</p>
            <p style={{margin: '0', fontWeight: 'bold'}}>Address: P. O. Box 2703, Sunyani, Ghana.</p>
            <p style={{margin: '0', fontWeight: 'bold'}}>Email: samuel.worwui@gmail.com</p>
            </div>
          </div>
        
        <nav style={{backgroundColor: 'green'}} class="navbar navbar-expand-sm">
    <div class="container">
        <button class="navbar-toggler bg-danger" data-toggle="collapse" data-target="#navbarCollapse">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav ">
            <li class="nav-item">
          <a href="/"  class="nav-link">Home</a>
            </li>
            <li class="nav-item">
          <a href="/About" class="nav-link">About Us</a>
            </li>
            <li class="nav-item">
          <a href="/Project" class="nav-link">Smart Eco-City</a>
            </li>
            <li class="nav-item">
          <a href="/ProS" class="nav-link">Product & Services</a>
            </li>
            <li class="nav-item">
          <a href="/Invest" class="nav-link">Investing in Smart Eco-city</a>
            </li>
  	<li class="nav-item">
          <a href="/" class="nav-link">Contact</a>
            </li>
          </ul>
        </div>
    </div>
  </nav>
  </div>
      </div>
    )
  }
}
export default Nav;
